var map = {
	"./alipay.js": [
		"9t3b",
		96
	],
	"./baidu.js": [
		"pt+y",
		95
	],
	"./jtapp.js": [
		"f6mB",
		0,
		37
	],
	"./wechat.js": [
		"bt54",
		94
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "+lmT";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/utils/newJtjssdk/jssdk lazy ^\.\/.*\.js$
// module id = +lmT
// module chunks = 98